import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getPostKey } from '../../utils/keys';
import { useCachedPost } from '../cache';
export const usePost = (options) => {
    const { variables, fields = 'default', useQueryOptions } = options;
    const { client } = useTribeClient();
    const postKey = getPostKey({ variables, fields });
    const placeHolderPost = useCachedPost(variables === null || variables === void 0 ? void 0 : variables.id);
    return useQuery(postKey, () => client.posts.get(variables, fields), {
        placeholderData: () => placeHolderPost,
        ...useQueryOptions,
    });
};
//# sourceMappingURL=usePost.js.map